var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect, _rect2, _path14, _path15, _path16, _path17, _path18, _path19, _ellipse, _polygon, _path20, _polygon2, _path21, _path22, _path23, _path24, _circle, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _rect3, _rect4, _rect5, _circle2, _circle3, _circle4, _rect6, _rect7, _path39, _polygon3, _path40, _path41, _polygon4, _path42, _path43, _circle5, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArbeitsrechtKuendigungsschutz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 809.7 462.6",
    style: {
      enableBackground: "new 0 0 809.7 462.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#E6E6E6;}\n\t.st2{fill:#F2F2F2;}\n\t.st3{fill:#CACACA;}\n\t.st4{fill:#CCCCCC;}\n\t.st5{fill:#E4E4E4;}\n\t.st6{fill:#FFFFFF;}\n\t.st7{fill:#3F3D56;}\n\t.st8{fill:#9E616A;}\n\t.st9{fill:#2F2E41;}\n\t.st10{fill:#137F7B;}\n\t.st11{fill:#FFB6B6;}\n\t.st12{fill:#FFB8B8;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.1,210.3v-130c0-3.9,3.1-7,7-7s7,3.1,7,7v130c0,3.9-3.1,7-7,7S133.1,214.2,133.1,210.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.3,210.3v-130c0-3.9,3.1-7,7-7s7,3.1,7,7v130c0,3.9-3.1,7-7,7S116.3,214.2,116.3,210.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.6,210.3v-130c0-3.9,3.1-7,7-7s7,3.1,7,7v130c0,3.9-3.1,7-7,7S99.6,214.2,99.6,210.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M732,418c-2.8,0-5.6-0.5-8.3-1.4l-0.4-0.1l0.2-0.9c-4.8-9.6-3.1-22.8,4.3-33.6c6.7-9.8,16.8-17,25.8-23.3 c3.1-2.2,7.5-1.5,9.7,1.7c1.1,1.6,1.5,3.5,1.1,5.3l-3.2,16.4c-2.3,11.9-5.1,23.1-13.2,30.1C743.5,415.9,737.8,418,732,418z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M753,446.4c-6.3,0-12.2-3.3-15.6-8.6l-0.2-0.4l0.6-0.5c1.4-7.8,8.2-14.8,17.2-17.8c8.2-2.7,17.3-2.3,25.3-1.9 l0,0c3,0.1,5.2,2.7,5.1,5.6c-0.1,1.4-0.7,2.8-1.8,3.7l-9,8.1c-6.5,5.9-13.1,11.2-20.9,11.6C753.4,446.4,753.2,446.4,753,446.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M725,455.1c-1.3-9.9-2.7-19.9-1.8-29.9c0.8-8.9,3.5-17.6,8.9-24.7c2.9-3.8,6.3-7,10.3-9.6c1-0.7,2,1,1,1.7 c-6.9,4.5-12.2,11-15.1,18.6c-3.3,8.6-3.8,17.9-3.3,27c0.3,5.5,1.1,11,1.8,16.4c0.1,0.5-0.2,1-0.7,1.2 C725.7,455.9,725.1,455.6,725,455.1C725,455.1,725,455.1,725,455.1L725,455.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M721.3,460.7c6.4-11.6,13.8-24.5,27.1-28.6c3.7-1.1,7.6-1.5,11.4-1.2c1.2,0.1,0.9,2-0.3,1.9 c-6.5-0.5-12.9,1.2-18.2,4.9c-5.1,3.6-9.1,8.5-12.5,13.8c-2.1,3.2-3.9,6.6-5.8,9.9C722.4,462.6,720.7,461.8,721.3,460.7L721.3,460.7 z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M718.4,460.6l6.5,0.1l-39-208.2l-6.5,1.2l10.2,54h-32.8l10.2-54l-6.5-1.2l-38.7,208.2l6.1-0.1l20.3-107.9h49.8 L718.4,460.6z M649.8,344.7l5.5-29h35.8l5.5,29H649.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M436.1,213.6v-68.4c0-2,3.1-3.7,7-3.7s7,1.7,7,3.7v68.4c0,2-3.1,3.7-7,3.7S436.1,215.7,436.1,213.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M419.3,213.6v-68.4c0-2,3.1-3.7,7-3.7s7,1.7,7,3.7v68.4c0,2-3.1,3.7-7,3.7S419.3,215.7,419.3,213.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M402.6,213.6v-68.4c0-2,3.1-3.7,7-3.7s7,1.7,7,3.7v68.4c0,2-3.1,3.7-7,3.7S402.6,215.7,402.6,213.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M543.5,163.4c-0.1-0.4-0.3-0.8-0.7-1l-52.8-34.8c0.8-0.3,1.5-0.9,1.9-1.7h0c1.1-1.9,0.4-4.4-1.5-5.5l-4.3-2.5 c-1.9-1.1-4.4-0.4-5.5,1.5c-0.3,0.5-0.5,1.1-0.5,1.6l-38.1-25.1c-2.6-6.3-7.8-11.1-14.3-13.2V71.6h-14v11.1c-9.5,3-16,11.9-16,21.9 v3h14c0,5,4,9,9,9s9-4,9-9h14v-3c0-1.4-0.1-2.9-0.4-4.3l96.4,63.6l-40,48.7c-0.3,0-0.6,0-0.9,0c-3.2,0-6.3,0.1-9.2,0.2 c0.2-0.5,0.3-1,0.2-1.5c-0.1-2.2-2-3.9-4.2-3.8l-5,0.3c-2.2,0.1-3.9,2-3.8,4.2c0,0.6,0.2,1.2,0.5,1.8c-8.8,0.9-14.6,2.2-14.6,2.9 c0,1.1,15.4,0.1,34.6,0c0.3,0.8,1.1,1.2,1.9,0.9c0.3-0.1,0.5-0.3,0.7-0.5l0.4-0.5c19.2,0.1,34.5,1.1,34.5,0c0-1-13.6-3.5-31.2-3.9 l39.6-48.1C543.4,164.2,543.6,163.8,543.5,163.4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M544.9,461.1H421.7c-5.2,0-9.4-4.2-9.4-9.4V249.5c0-4.6-3.8-8.4-8.4-8.4H115.7c-4.6,0-8.4,3.8-8.4,8.4v202.2 c0,5.2-4.2,9.4-9.4,9.4h-4.2c-5.2,0-9.4-4.2-9.4-9.4V238.6c0-12.4,10.1-22.5,22.5-22.5h425c12.4,0,22.5,10.1,22.5,22.5v213.1 C554.3,456.9,550.1,461.1,544.9,461.1z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 412.8,
    y: 268.6,
    className: "st6",
    width: 141,
    height: 6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 412.8,
    y: 349.6,
    className: "st6",
    width: 141,
    height: 6
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296.1,215.1l-4.1-1.7l-2.8-20.3h-37l-3,20.2l-3.6,1.8c-0.4,0.2-0.6,0.7-0.4,1.2c0.1,0.3,0.4,0.5,0.8,0.5h49.8 c0.5,0,0.9-0.4,0.9-0.9C296.6,215.5,296.4,215.2,296.1,215.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M361.9,195.8H180.1c-2,0-3.6-1.6-3.6-3.6v-25.6h189v25.6C365.5,194.2,363.9,195.8,361.9,195.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M365.7,178.6H176.3V68.9c0-2.4,1.9-4.3,4.3-4.3h180.7c2.4,0,4.3,1.9,4.3,4.3V178.6z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M354.4,170.7H187.6c-1.8,0-3.3-1.5-3.3-3.3V75.9c0-1.8,1.5-3.3,3.3-3.3h166.8c1.8,0,3.3,1.5,3.3,3.3v91.4 C357.7,169.2,356.2,170.7,354.4,170.7z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M541.3,83c6-0.9,11.6,3.3,12.5,9.3c0.1,0.6,0.1,1.3,0.1,1.9l36.6,14.1l-16.6,11.8l-32.2-15.2 c-6.1-0.6-10.5-6-9.9-12.1C532.3,87.8,536.3,83.7,541.3,83L541.3,83z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M680.2,76.1l6.2,11.2c-1.5,7.1-5.4,13.6-11,18.2c-9.5,8-59,37.7-59,37.7l-62.5-31.4l10.9-14.5l49.1,16.4l0,0 c18.2-17.2,40.2-29.9,64.2-37.1L680.2,76.1z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 668.7,
    cy: 246.3,
    rx: 48.8,
    ry: 15.9
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "559.2,447.1 546.3,443.5 553.9,391.8 573,397.1 "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M559,460.6L517.3,449l0.1-0.5c2.5-9,11.8-14.2,20.8-11.8l0,0l25.5,7.1L559,460.6z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "521.7,447.3 509.4,441.8 524.4,391.8 542.6,399.8 "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M519.5,460.6l-39.6-17.5l0.2-0.5c3.8-8.5,13.7-12.4,22.2-8.6l0,0l24.2,10.7L519.5,460.6z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M706.6,207.5c0,0,6.5,20.2-33.5,45.7l-51.5,51.3l-53.5,128l-31.8-14.2l6.2-16.6l4.2-11.2l2.1-5.7l2.3-6.1 l34-90.8l28.6-50l0.8-27.1l7-19.1l51-18.1L706.6,207.5z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M680.6,208.5c0,0,6.5,20.2-33.5,45.7l-51.5,51.3l-53.5,128l-31.8-14.2l6.2-16.6l4.2-11.2l2.1-5.7l2.3-6.1 l34-90.8l9.6-16.7c12.6-22.1,28-42.5,45.6-60.8l9.4-9.7l1-15l21.8-12.1L680.6,208.5z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M649.8,109.6l16-34l27.9-3.8c0,0,21.8,27.8,16.1,66.8c-2.1,14.6-3.9,29.2-4,42c0,3.4,2.9,4.9,3,8 c0,3-5.6,7.9-4,10c2.3,2.8,3.7,6.3,4,10c-2,4.7-62-20.8-87.2-17L649.8,109.6z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 667.8,
    cy: 41.8,
    r: 25.3
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M683.9,32.7c0,0.7-0.1,1.5-0.2,2.5c-0.1,2.7,0.7,5.4,2.2,7.7c1.4,2.4-0.3,16.8-0.3,16.8 c41.4-28.8,8.7-57.8-4.1-55.2c0.3-3.7-10.2-2.2-10.2-2.2c-4-6.2-12.7,2-12.7,2l1.7-2.8C653.6,3.2,647,24.1,647,24.1 C649.2,33.1,684.2,29,683.9,32.7z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M523.5,123c14.2-18.9,25.5-39.9,33.3-62.2c0.9-2.8-0.2-5.8-2.8-7.2l-48.6-26.1c-1.6-0.9-3.5-0.9-5.2-0.2 c-1.7,0.7-2.9,2.2-3.4,4c-5.7,21.5-16.3,41.4-31.1,58c-1.2,1.4-1.8,3.2-1.4,5c0.3,1.8,1.4,3.3,3,4.2l48.6,26.1 C518.5,126,521.7,125.3,523.5,123z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M520.1,120.5c-0.5,0.7-1.5,0.9-2.2,0.5l-48.6-26.1c-0.5-0.2-0.8-0.7-0.9-1.2c-0.1-0.6,0.1-1.1,0.4-1.6 c15.2-17.1,26.2-37.6,32-59.7c0.1-0.6,0.5-1,1-1.2c0.5-0.2,1.1-0.2,1.5,0.1L552,57.3c0.8,0.4,1.1,1.3,0.9,2.1 C545.1,81.3,534.1,101.9,520.1,120.5z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M503.1,56l33.6,19.7c3.3,2,6.4-3.2,3-5.2l-33.6-19.7C502.8,48.8,499.8,54,503.1,56L503.1,56z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M497.1,67l33.6,19.7c3.3,2,6.4-3.2,3-5.2l-33.6-19.7C496.8,59.8,493.8,65,497.1,67L497.1,67z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M490.1,79l33.6,19.7c3.3,2,6.4-3.2,3-5.2l-33.6-19.7C489.8,71.8,486.8,77,490.1,79L490.1,79z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M483.1,89l33.6,19.7c3.3,2,6.4-3.2,3-5.2l-33.6-19.7C482.8,81.8,479.8,87,483.1,89L483.1,89z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M636.1,204.7l12.6,28.3c0.6,1.4,0.5,3-0.3,4.2c-1,1.5-2.8,2.3-4.5,2c-0.3,0-0.6-0.1-0.9-0.2 c-1.1-0.4-2-1.3-2.5-2.4l-12.6-28.3c-1-2.3,0-4.9,2.3-5.9C632.4,201.4,635.1,202.4,636.1,204.7C636.1,204.7,636.1,204.7,636.1,204.7 L636.1,204.7z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M647.6,230.7l2.5,5.7l1.3,8.1c0.2,1.3-0.7,2.6-2,2.8c-0.9,0.1-1.7-0.2-2.3-0.9l-5.2-6.5l-2.5-5.6L647.6,230.7z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M625,196.8l1.8,11.3c0.2,1.3,1.5,2.2,2.8,2c0.2,0,0.4-0.1,0.6-0.2l1.8-0.8l3.5,7.8c0.2,0.5,0.8,0.7,1.3,0.5 c0.5-0.2,0.7-0.8,0.5-1.3l-3.5-7.8l1.8-0.8c1.2-0.6,1.8-2,1.2-3.2c-0.1-0.2-0.2-0.4-0.3-0.5l-7.2-8.9c-0.9-1.1-2.4-1.2-3.4-0.4 C625.2,195,624.9,195.9,625,196.8z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M630.3,217.3c1.1-6,6.8-10,12.8-8.9c0.6,0.1,1.3,0.3,1.9,0.5l24.9-30.3l6,19.4l-24.5,25.8 c-2.5,5.6-9,8.1-14.6,5.6C632,227.3,629.3,222.3,630.3,217.3L630.3,217.3z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M661.6,215.3l-11-15.8l31.1-41.5l-16-34.3l1.2-40.8l13.2-2.4l0.2,0.1c6.4,3.7,11.4,9.5,14.1,16.4 c3.3,8.3,10.7,39.3,14.8,57c1.6,7-0.5,14.3-5.6,19.4L661.6,215.3z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M353.2,138.8c-0.1,0.8-0.1,1.5-0.1,2.3L297.1,182l-15.4-6.8L268.3,197l26.1,14.7c4.3,2.4,9.8,1.7,13.3-1.7 l56.4-55.1c7.9,2,15.8-2.8,17.8-10.6c2-7.9-2.8-15.8-10.6-17.8c-7.9-2-15.8,2.8-17.8,10.6C353.4,137.6,353.3,138.2,353.2,138.8 L353.2,138.8z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M295.2,183.4l-16.4,27.2c-1.8,3-5.7,3.9-8.6,2.2c-0.3-0.2-0.5-0.3-0.8-0.5L245,192.2c-8.2-5-10.9-15.8-5.8-24 c5-8.2,15.7-10.8,23.9-5.9l29.2,12.1c3.2,1.3,4.7,5,3.4,8.2C295.5,182.9,295.4,183.2,295.2,183.4L295.2,183.4z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 225.2,
    y: 367.2,
    className: "st3",
    width: 32.1,
    height: 53.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 288.4,
    y: 377.9,
    transform: "matrix(0.5615 -0.8275 0.8275 0.5615 -223.1309 427.7472)",
    className: "st3",
    width: 7.3,
    height: 93
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 143.9,
    y: 420.7,
    transform: "matrix(0.8275 -0.5615 0.5615 0.8275 -205.4593 180.1154)",
    className: "st3",
    width: 93,
    height: 7.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 330.5,
    cy: 450.5,
    r: 10.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 240.7,
    cy: 450.5,
    r: 10.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 151.9,
    cy: 450.5,
    r: 10.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 237.1,
    y: 398.3,
    className: "st3",
    width: 7.3,
    height: 52.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 234.3,
    y: 320.5,
    className: "st3",
    width: 13.7,
    height: 70.5
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M201.8,331.5V315c0-6.3,5.1-11.4,11.4-11.4h61.4c6.3,0,11.4,5.1,11.4,11.4v16.5c0,6.3-5.1,11.4-11.4,11.4h-61.4 C206.9,342.9,201.8,337.8,201.8,331.5z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "312.6,444.1 329.6,444.1 337.7,400.1 312.6,400.1 "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M308.3,460.6l54.7,0v-0.7c0-11.8-9.5-21.3-21.3-21.3l0,0h0l-33.4,0L308.3,460.6z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M338,416.8l33.8-75.9c5.9-13.3,0.5-28.8-12.2-35.7l-73.4-39.3l-33.5-2.8l-30.9-2.8l-0.2,0.4 c-0.3,0.5-6.9,12-2.4,24.5c3.4,9.5,12.3,17,26.3,22.1c32.8,12,70.7,22.3,85.5,26.2c1.3,0.3,2.4,1.2,3.1,2.4c0.6,1.2,0.7,2.6,0.3,3.9 L303,410.4c-1.2,3.2,0.5,6.8,3.7,8c0.5,0.2,1,0.3,1.6,0.4l23.5,1.7c0.2,0,0.4,0,0.6,0C334.8,420.5,337,419.1,338,416.8z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "301.6,444.1 318.5,444.1 326.6,400.1 301.6,400.1 "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M297.2,460.6l54.7,0v-0.7c0-11.8-9.5-21.3-21.3-21.3l0,0h0l-33.4,0L297.2,460.6z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M325.6,421l33.8-75.9c5.9-13.3,0.5-28.8-12.2-35.7l-73.4-39.3l-33.5-2.8l-24.2-2.1l0-0.3 c-0.3,0.5-6.9,12-2.4,24.5c3.4,9.5,5.3,17,19.4,22.1c32.8,12,70.7,22.3,85.5,26.2c1.3,0.3,2.4,1.2,3.1,2.4c0.6,1.2,0.7,2.6,0.3,3.9 l-31.4,70.6c-1.2,3.2,0.5,6.8,3.7,8c0.5,0.2,1,0.3,1.6,0.4l23.5,1.7c0.2,0,0.4,0,0.6,0C322.3,424.7,324.6,423.2,325.6,421z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 271.3,
    cy: 86.4,
    r: 34
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M388.5,217c14.2-18.9,25.5-39.9,33.3-62.2c0.9-2.8-0.2-5.8-2.8-7.2l-48.6-26.1c-1.6-0.9-3.5-0.9-5.2-0.2 c-1.7,0.7-2.9,2.2-3.4,4c-5.7,21.5-16.3,41.4-31.1,58c-1.2,1.4-1.8,3.2-1.4,5c0.3,1.8,1.4,3.3,3,4.2l48.6,26.1 C383.5,220,386.7,219.3,388.5,217z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M385.1,214.5c-0.5,0.7-1.5,0.9-2.2,0.5l-48.6-26.1c-0.5-0.2-0.8-0.7-0.9-1.2c-0.1-0.6,0.1-1.1,0.4-1.6 c15.2-17.1,26.2-37.6,32-59.7c0.1-0.6,0.5-1,1-1.2c0.5-0.2,1.1-0.2,1.5,0.1l48.6,26.1c0.8,0.4,1.1,1.3,0.9,2.1 C410.1,175.3,399.1,195.9,385.1,214.5z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M368.1,150l33.6,19.7c3.3,2,6.4-3.2,3-5.2l-33.6-19.7C367.8,142.8,364.8,148,368.1,150L368.1,150z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M362.1,161l33.6,19.7c3.3,2,6.4-3.2,3-5.2l-33.6-19.7C361.8,153.8,358.8,159,362.1,161L362.1,161z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M357.4,171.9l30.5,18.1c3,1.8,6.3-1.9,3.3-3.7l-30.5-18.1C357.6,166.4,354.4,170.1,357.4,171.9z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M348.1,183l33.6,19.7c3.3,2,6.4-3.2,3-5.2l-33.6-19.7C347.8,175.8,344.8,181,348.1,183L348.1,183z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M290.9,268.7l-67.3-0.4l0-0.5c-1.3-33.8,2.8-64.3,12.6-93.5c0.1-1.1,0.3-2.3,0.4-3.4c1.7-13,3-23.4,15.4-27.2 c-1-1.4-1.6-3-1.8-4.7c-0.2-2.3,0.6-4.6,2.1-6.3c1.5-1.7,3.5-2.7,5.8-2.8l23.9-0.8c1.3,0,2.5,0.4,3.5,1.2c3.8,2.8,4.9,7.9,2.8,12.1 c-0.3,0.6-0.4,0.8-0.4,0.9c0.9,4.5,3.4,9.8,6,15.4c3.8,8,8.2,17.1,9.3,26.9c0.6,5.3,0.4,10.6-0.7,15.7c-0.5,2.8-0.6,5.6-0.3,8.5 c0.2,4.2,0.4,8.1-1.9,11.9c-0.6,1-1.3,2.1-2.1,3.4l-3.3,7.9L290.9,268.7z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M189.9,315.9V178.5c0-9.3,7.6-16.9,16.9-16.9h4.7c9.3,0,16.9,7.6,16.9,16.9v137.5c0,9.3-7.6,16.9-16.9,16.9 h-4.7C197.5,332.8,189.9,325.3,189.9,315.9z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M370.3,192.2c-0.5,0.6-0.9,1.2-1.3,1.9l-69.2,5l-9.5-13.9l-22.9,11.6l14.4,26.3c2.4,4.4,7.4,6.6,12.2,5.5 l77-17c5.6,5.8,14.9,6,20.8,0.4c5.8-5.6,6-14.9,0.4-20.8c-5.6-5.8-14.9-6-20.8-0.4C371.1,191.3,370.7,191.7,370.3,192.2z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M297.5,199.5L269.3,214c-3.1,1.6-6.9,0.4-8.5-2.7c-0.1-0.3-0.3-0.6-0.4-0.9l-10.2-30c-4.3-8.6-0.9-19,7.6-23.4 c-12.5,6.4,13.6-11.8,23.5,7.6l18.4,25.7c2,2.8,1.4,6.8-1.5,8.8C298.1,199.2,297.8,199.3,297.5,199.5L297.5,199.5z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M255.9,119.4c-2,0-4.3-1-6.8-3c-15.4-12.1-20.8-33-13.3-51c1.9-4.4,5.3-10.4,11.3-14c4.3-2.5,9.3-3.4,13.7-4.1 c3.8-0.6,7.7-1,11.5-1.3c4.5-0.4,9.8-0.6,14.5,1.2c3.5,1.3,6.5,3.7,9.4,6c1,0.8,2,1.6,3.1,2.4c2.5,2,5.4,3.4,8.5,4.1 c1.3,0.3,2.5,1.1,3.1,2.3c0.7,1.2,0.8,2.6,0.3,3.9c-0.4,1.3-0.9,2.4,0,3.6c0.6,0.9,1.6,1.4,2.7,1.4c0.6,0,1.1,0.3,1.4,0.7 c0.3,0.5,0.4,1.1,0.2,1.6l-0.1,0.3c0.7,0.1,1.4,0.5,1.7,1.1c0.5,0.9,0.4,2.1-0.4,2.8c-3,2.9-6.8,4.9-10.9,5.7 c-2.8,0.6-5.7,0.5-8.5,0l-0.5-0.1l0.1-0.5c-11.3-4-21.6,2.8-27.4,10.7l-0.8-0.5c0.3-0.6,0.3-1.3,0.1-1.9c-0.2-0.7-0.8-1.4-1.5-1.7 c-1.4-0.6-3.1-0.3-4.1,0.8c-1.1,1.1-1.7,2.7-1.5,4.3c0.2,1.7,0.6,3.3,1.3,4.8c0.3,0.7,0.6,1.5,0.8,2.2c1.3,4.3,0.9,9-1,13 c-0.9,1.9-2.5,4.2-5.1,5C257,119.4,256.5,119.4,255.9,119.4z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M808.5,462.6H1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2h807.3c0.7,0,1.2,0.5,1.2,1.2 C809.7,462,809.1,462.6,808.5,462.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbeitsrechtKuendigungsschutz);
export default __webpack_public_path__ + "static/media/Arbeitsrecht_Kuendigungsschutz.21408f7d305ad89247279f847364f183.svg";
export { ForwardRef as ReactComponent };